export default __webpack_public_path__ + "static/media/IOS-d.8c4986ee.svg";